import { useEffect, useState, useMemo } from 'react';
import { ArchBuilder } from './ArchBuilder';
import { ArchBuilderPC } from './ArchBuilderPC';
import { ArchBuilderMobile } from './ArchBuilderMobile';

let globalBuilder: ArchBuilder =
  window.innerWidth > 768 ? new ArchBuilderMobile() : new ArchBuilderPC(); // Valor inicial por defecto

export const useGlobalBuilder = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  globalBuilder = useMemo(() => {
    return isMobile ? new ArchBuilderMobile() : new ArchBuilderPC();
  }, [isMobile]);

  return globalBuilder;
};

export { globalBuilder };
